import {Component, Input, ViewChild} from '@angular/core';
import {IconButtonTooltipComponent} from '@dcp/configurator';
import {Address} from '@spartacus/core';

@Component({
  selector: 'dcp-provided-by-tooltip',
  templateUrl: './provided-by-tooltip.component.html',
  styleUrls: ['./provided-by-tooltip.component.scss']
})
export class ProvidedByTooltipComponent {

  @Input() vendorAddress: Address;
  @ViewChild(IconButtonTooltipComponent) tooltip: IconButtonTooltipComponent;

   getTooltipText(): string {
    return this.vendorAddress?.formattedAddress || '';
  }
}
